import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { formatDate } from "../../../utils";
import OngoingGameBox from "../TestManagement/TestList/components/OngoingGameBox";

import AdModal from "./Modal/AdModal";

import image from "../../../assets/images/image.png";

import OverviewAPI from "./Data/OverviewAPI";
import CompanyInfoCheckAPI from "./Data/CompanyInfoCheckAPI";
import HomeSkipPromotionAPI from "./Data/HomeSkipPromotionAPI";
import MakerTesterOverviewAPI from "./Data/MakerTesterOverviewAPI";
import MakerGameProposalOverviewAPI from "./Data/MakerGameProposalOverviewAPI";
import { GameProposalOverviewAPI } from "../TestManagement/TestManagementApi";
import OnWritingGameBox from "../TestManagement/TestList/components/OnWritingGameBox";

const Main = styled.main`
  background-color: #f8f9fa;
  width: 100%;
  min-width: 1280px;
  padding-left: 320px;
  padding-top: 40px;
  height: 100%;
  padding-bottom: 200px;
  overflow-y: auto;
  height: calc(100vh - 200px);
`;

const CompanyInfoContainer = styled.div`
  // width: 1280px;
  width: 90%;
  height: 110px;
  background-color: white;
  padding: 0px 40px;
  border-radius: 5px;
  margin-bottom: 50px;
  font-weight: 500;
  color: #555555;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

const CompanyInfoSpan = styled.span`
  color: #2282e9;
  text-decoration: underline;
`;

const InfoWrapper = styled.div`
  // width: 1280px;
  width: 90%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
`;

const InfoContainer = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 30px 10px 32px 20px;
  align-items: center;
`;

const InfoTitleContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 28px;
  justify-content: center;
`;

const InfoTitle = styled.span`
  font-weight: 600;
  color: #2282e9;
  margin-right: 12px;
  text-align: center;
  margin: 0;
`;

const InfoDate = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: #9f9f9f;
`;

const CountWrapper = styled.div`
  display: grid;
  grid-template-columns: 146fr 64fr;
  height: 64px;
`;

const CountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 28px;
`;

const PersonnelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

const PersonnelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #797979;
  font-size: 12px;
  font-weight: 500;
`;

const ColorCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #2282e9;
`;

const TestcompleteCountContainer = styled.div`
  display: flex;
  padding-left: 10px;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 28px;
  height: 64px;
`;

const TestBtn = styled.button`
  // width: 1280px;
  width: 90%;
  height: 70px;
  margin-bottom: 50px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
`;

const Title = styled.span`
  display: block;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 20px;
`;

const BoxContainer = styled.div`
  margin-bottom: 50px;
`;

const BlankBox = styled.div`
  background-color: white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #c0c0c0;
  line-height: 26px;
  width: 300px;
  height: 300px;
`;

const BoxContent = styled.div`
  width: 300px; // 고정 너비
  min-width: 300px; // 최소 너비 설정
  height: 300px;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  flex-shrink: 0; // 크기 축소 방지
`;

const BoxLinear = styled.div`
  width: 300px; // 고정 너비
  min-width: 300px; // 최소 너비 설정
  height: 300px;
  border-radius: 5px;
  position: absolute;
  top: 0px;
  left: 0px;
  background: linear-gradient(#ffffff00, #ffffff51 55%, #ffffff 75%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 26px 30px;
  box-sizing: border-box; // padding이 너비에 영향을 주지 않도록 설정
`;

const BoxTitle = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 13px;
`;

const BoxDate = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #9f9f9f;
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 90%;
  overflow-x: auto;
  margin-bottom: 50px;
`;

export default function Home() {
  const [modal, setModal] = useState(false);
  const queryClient = useQueryClient();

  function modalClose(check: boolean) {
    if (check) {
      CallPromotionMutationAPI();
    }
    setModal(false);
  }

  const { data: overviewData } = useQuery({
    queryKey: ["overview"],
    queryFn: async () => {
      const response = await OverviewAPI();
      return response.data;
    },

    // initialData: {
    //   showPromotionPopup: true,
    //   projectCount: 0,
    //   plimoney: 0,
    // },
    enabled: true,
  });

  const { data: companyInfoCheckData, isLoading } = useQuery({
    queryKey: ["companyInfoCheck"],
    queryFn: async () => {
      const response = await CompanyInfoCheckAPI();
      return response.data;
    },
    // initialData: {
    //   everApproved: false,
    // },
    enabled: true,
  });

  const { data: MakerGameProposalOverviewData } = useQuery({
    queryKey: ["MakerGameProposalOverview"],
    queryFn: async () => {
      const response = await GameProposalOverviewAPI();
      return response.data;
    },
    // initialData: {
    //   draftGames: [
    //     {
    //       gameProposalId: 2,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //     },
    //     {
    //       gameProposalId: 5,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 6,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 7,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 8,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 9,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     }
    //   ],
    //   ongoingGames: [
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //   ],
    //   expiredGames: [
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //   ]
    // },
    enabled: true,
  });

  const navigate = useNavigate();
  const showDashboard = (gameId: number) => {
    navigate(`/home/test-list/${gameId}/dashboard`);
  };

  const { data: makerTesterOverviewData, refetch: makerTesterOverviewRefetch } =
    useQuery({
      queryKey: ["makerTesterOverview"],
      queryFn: async () => await MakerTesterOverviewAPI(),
      enabled: true,
    });

  const homeSkipPromotionMutation = useMutation({
    mutationFn: HomeSkipPromotionAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["homeSkipPromotionMutation"],
      });
    },
  });

  const CallPromotionMutationAPI = async () => {
    homeSkipPromotionMutation.mutate();
  };

  useEffect(() => {
    if (overviewData?.showPromotionPopup) {
      setModal(true);
    } else {
      setModal(false);
    }
  }, [overviewData?.showPromotionPopup]);

  useEffect(() => {
    if (companyInfoCheckData?.everApproved) {
      makerTesterOverviewRefetch();
    }
  }, [companyInfoCheckData?.everApproved, makerTesterOverviewRefetch]);

  return (
    <Main>
      {!isLoading && companyInfoCheckData?.everApproved === false && (
        <CompanyInfoContainer>
          <span>
            잠깐! 프로젝트 진행을 위해 반드시 게임사 인증이 필요합니다. 필요한
            자료 제출을 완료하셨을까요?
          </span>
          <Link to="/home/company-info" style={{ textDecoration: "none" }}>
            <CompanyInfoSpan>게임사 인증하기</CompanyInfoSpan>
          </Link>
        </CompanyInfoContainer>
      )}

      <InfoWrapper>
        <InfoContainer>
          <InfoTitleContainer>
            <InfoTitle>참여 인원</InfoTitle>
            <InfoDate>{formatDate(Date())} 기준</InfoDate>
          </InfoTitleContainer>
          <CountWrapper>
            <CountContainer>
              {makerTesterOverviewData
                ? makerTesterOverviewData.data.participants.total + "명"
                : "--"}
            </CountContainer>

            <PersonnelWrapper>
              <PersonnelContainer>
                <ColorCircle></ColorCircle>
                <span>
                  승인{" "}
                  {makerTesterOverviewData
                    ? makerTesterOverviewData.data.participants.approved
                    : "-"}
                  명
                </span>
              </PersonnelContainer>
              <PersonnelContainer>
                <ColorCircle
                  style={{ backgroundColor: "#FF1F00" }}
                ></ColorCircle>
                <span>
                  반려{" "}
                  {makerTesterOverviewData
                    ? makerTesterOverviewData.data.participants.rejected
                    : "-"}
                  명
                </span>
              </PersonnelContainer>
              <PersonnelContainer>
                <ColorCircle
                  style={{ backgroundColor: "#8E8E8E" }}
                ></ColorCircle>
                <span>
                  대기{" "}
                  {makerTesterOverviewData
                    ? makerTesterOverviewData.data.participants.pending
                    : "-"}
                  명
                </span>
              </PersonnelContainer>
            </PersonnelWrapper>
          </CountWrapper>
        </InfoContainer>
        <InfoContainer>
          <InfoTitleContainer>
            <InfoTitle>설문 참여 중 인원</InfoTitle>
            <InfoDate>{formatDate(Date())} 기준</InfoDate>
          </InfoTitleContainer>
          <TestcompleteCountContainer>
            {makerTesterOverviewData
              ? makerTesterOverviewData.data.archivedCount + "명"
              : "--"}
          </TestcompleteCountContainer>
        </InfoContainer>
        <InfoContainer>
          <InfoTitleContainer>
            <InfoTitle>설문 제출 완료 인원</InfoTitle>
            <InfoDate>{formatDate(Date())} 기준</InfoDate>
          </InfoTitleContainer>
          <TestcompleteCountContainer>
            {makerTesterOverviewData
              ? makerTesterOverviewData.data.submittedCount + "명"
              : "--"}
          </TestcompleteCountContainer>
        </InfoContainer>
        <InfoContainer>
          <InfoTitleContainer>
            <InfoTitle>테스트 완료 인원</InfoTitle>
            <InfoDate>{formatDate(Date())} 기준</InfoDate>
          </InfoTitleContainer>
          <TestcompleteCountContainer>
            {makerTesterOverviewData
              ? makerTesterOverviewData.data.approvedCount + "명"
              : "--"}
          </TestcompleteCountContainer>
        </InfoContainer>
      </InfoWrapper>
      <TestBtn onClick={() => navigate("/home/test-list/add")}>
        테스트 등록하기
      </TestBtn>
      <Title>진행 중인 게임 테스트</Title>
      <ContentWrapper>
        {MakerGameProposalOverviewData?.ongoingGames.length === 0 ? (
          <BlankBox>
            현재 진행 중인 <br />
            테스트가 없습니다 :(
          </BlankBox>
        ) : (
          MakerGameProposalOverviewData?.ongoingGames.map((game: any) => (
            <OngoingGameBox
              key={game.gameId}
              game={game}
              onClick={() => showDashboard(game.gameId)}
            />
          ))
        )}
      </ContentWrapper>
      <Title>작성 중인 게임 테스트</Title>
      <ContentWrapper>
        {MakerGameProposalOverviewData?.draftGames.length === 0 ? (
          <BlankBox>
            작성 중인 <br />
            테스트가 없습니다 :(
          </BlankBox>
        ) : (
          MakerGameProposalOverviewData?.draftGames.map((game: any) => (
            <OnWritingGameBox key={game.gameId} game={game}></OnWritingGameBox>
          ))
        )}
      </ContentWrapper>
    </Main>
  );
}
